"use strict";

var React = require('react'),
    DocumentTitle = require('react-document-title'),
    ToolboxSidebar = require('./Sidebar'),
    Header = require('./Header'),
    Footer = require('./Footer'),
    Images = require('../project/ProjectImages');

var ToolboxImages = React.createClass({displayName: "ToolboxImages",
    render: function() {
        var me = this,
            props = me.props,
            state = me.state,
            emptyMessage = 'There are no images available. Use the form to the left to send the builder a quick message to to inquire about available images.',
            description = (
                React.createElement("h5", null, "Below are images for ", React.createElement("span", {className: "blue-text"}, props.project.get('name')), ". Click on the “Download” button to download the file")
            ),
            title = props.title + ' - Images';

        return (
            React.createElement("div", {className: "wrapper"}, 
                React.createElement(DocumentTitle, {title: title}), 
                React.createElement(Header, {project: props.project, builder: props.builder}), 
                React.createElement("div", {className: "container content"}, 
                    React.createElement("div", {className: "row"}, 
                        React.createElement(ToolboxSidebar, {project: props.project, showContactForm: true}), 
                        React.createElement("div", {className: "col-sm-9"}, 
                            React.createElement(Images, {model: props.project, readOnly: true, emptyMessage: emptyMessage, hidePrivate: true, showDownload: true, description: description})
                        ), 
                        React.createElement(Footer, {trackerId: "agent-toolbox-images"})
                    )
                )
            )
        );
    }
});

module.exports = ToolboxImages;
